import dayjsLocaleAr from 'dayjs/locale/ar';
import dayjsLocaleEn from 'dayjs/locale/en';
import dayjsLocaleTr from 'dayjs/locale/tr';
import { Arabic } from 'flatpickr/dist/l10n/ar.js';
import { english } from 'flatpickr/dist/l10n/default.js';
import { Turkish } from 'flatpickr/dist/l10n/tr.js';
import i18n from 'i18next';

import { initReactI18next } from 'react-i18next';

export const languages = [
	{
		code: 'engValue',
		systemCode: 'en_US',
		name: 'English',
		key: 'english',
		dir: 'ltr',
		languageCode: 'en',
		icon: 'https://storage.googleapis.com/tryoto-public/public/assets/flags/us.svg',
		dayjsLocale: dayjsLocaleEn,
		flatpickrLocale: english,
		tinyMCELanguage: undefined, // TinyMCE's default locale is English
		tinyMCELanguageUrl: undefined // TinyMCE's default locale is English
	},
	{
		code: 'arabicValue',
		systemCode: 'ar_SA',
		name: 'العربية',
		key: 'arabic',
		dir: 'rtl',
		languageCode: 'ar',
		icon: 'https://storage.googleapis.com/tryoto-public/public/assets/flags/sa.svg',
		dayjsLocale: dayjsLocaleAr,
		flatpickrLocale: Arabic,
		tinyMCELanguage: 'ar',
		tinyMCELanguageUrl: '/assets/js/langs/ar.js'
	},
	{
		code: 'trValue',
		systemCode: 'tr_TR',
		name: 'Türkçe',
		key: 'turkish',
		dir: 'ltr',
		languageCode: 'tr',
		icon: 'https://storage.googleapis.com/tryoto-public/public/assets/flags/tr.svg',
		dayjsLocale: dayjsLocaleTr,
		flatpickrLocale: Turkish,
		tinyMCELanguage: 'tr',
		tinyMCELanguageUrl: '/assets/js/langs/tr.js'
	}
];

i18n.use(initReactI18next) // pass the i18n instance to react-i18next.
	.init({
		lng: 'engValue', // default language is english.
		fallbackLng: 'engValue', // fallback language is english.
		supportedLngs: ['engValue', 'arabicValue', 'trValue'], // supported languages, backend needs this typo for filtering in db.
		ns: ['translation'], // default namespace is translation. currently only one namespace is supported.
		partialBundledLanguages: true,
		interpolation: {
			escapeValue: false // not needed for react as it escapes by default
		},
		returnEmptyString: false, // allow an empty value to count as invalid (by default is true),
		nsSeparator: false, // namespace separator
		react: {
			useSuspense: false,
			transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'b', 'p', 'span', 'ul', 'ol', 'li', 'pre', 'code']
		}
	});

export default i18n;
